import cn from 'classnames';
import React from 'react';

import Text from '@sats-group/ui-lib/react/text';

import Icon120 from './icon-120x120';
import Icon24 from './icon-24x24';
import Icon48 from './icon-48x48';

import { SpinnerProps, colors, sizes, themes } from './spinner.props';

const Spinner: React.FunctionComponent<SpinnerProps> & {
  sizes: typeof sizes;
  themes: typeof themes;
  colors: typeof colors;
} = ({
  text,
  size = Spinner.sizes.medium,
  theme,
  color = Spinner.colors.blue,
}) => (
  <div
    className={cn('spinner', {
      [`spinner--${theme}`]: theme,
      [`spinner--${size}`]: size,
      'spinner--overlay-dark': text,
    })}
  >
    <div
      className={cn('spinner__content', {
        'spinner__content--with-background': text,
      })}
    >
      <span
        className={cn('spinner__icon', {
          [`spinner__icon--${color}`]: color,
        })}
      >
        {size === sizes.small ? (
          <Icon24 />
        ) : size === sizes.medium ? (
          <Icon48 />
        ) : size === sizes.large ? (
          <Icon120 />
        ) : null}
      </span>
      <Text size={Text.sizes.basic}>{text}</Text>
    </div>
  </div>
);

Spinner.sizes = sizes;
Spinner.themes = themes;
Spinner.colors = colors;

export default Spinner;
